export const FEEDBACK_SUBMIT_REQUEST = 'feedback_submit_request';
export const FEEDBACK_SUBMIT_SUCCESS = 'feedback_submit_success';
export const FEEDBACK_SUBMIT_FAILURE = 'feedback_submit_failure';
export const FEEDBACK_RESET = 'feedback_reset';

export const CLEAR_FEEDBACK_ERROR = 'clear_feedback_error';
